const Orderreq = [
    {
      customerId: "C001",
      customerName: "Amit Kumar",
      location: "123 MG Road, Bangalore, Karnataka",
      orderDate: "2024-12-12",
      meds: [
        {
          name: "Med1",
          description: "Pain reliever for headaches and minor aches.",
          company: "PharmaCorp",
          expiryDate: "2026-05-01",
          tags: ["Pain", "Headache", "Anti-inflammatory"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 2
        },
        {
          name: "Med2",
          description: "Antibiotic for bacterial infections.",
          company: "MediPharm",
          expiryDate: "2025-08-15",
          tags: ["Antibiotic", "Infection", "Bacterial"],
          ageGroups: ["Adults", "Children"],
          quantity: 1
        }
      ]
    },
    {
      customerId: "C002",
      customerName: "Priya Sharma",
      location: "456 Lajpat Nagar, Delhi",
      orderDate: "2024-12-12",
      meds: [
        {
          name: "Med3",
          description: "Cough syrup for relief from coughing.",
          company: "CoughLabs",
          expiryDate: "2024-12-31",
          tags: ["Cough", "Cold", "Relief"],
          ageGroups: ["Adults", "Children"],
          quantity: 3
        },
        {
          name: "Med4",
          description: "Vitamins for daily health support.",
          company: "NutriLife",
          expiryDate: "2027-02-20",
          tags: ["Vitamins", "Health", "Daily"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 1
        }
      ]
    },
    {
      customerId: "C003",
      customerName: "Ravi Patel",
      location: "789 Nehru Street, Ahmedabad, Gujarat",
      orderDate: "2024-12-13",
      meds: [
        {
          name: "Med5",
          description: "Allergy medication for seasonal allergies.",
          company: "AllerMed",
          expiryDate: "2026-09-10",
          tags: ["Allergy", "Relief", "Seasonal"],
          ageGroups: ["Adults", "Children"],
          quantity: 2
        },
        {
          name: "Med6",
          description: "Blood pressure medication.",
          company: "CardioPharm",
          expiryDate: "2025-03-01",
          tags: ["Blood Pressure", "Hypertension", "Cardiovascular"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 1
        }
      ]
    },
    {
      customerId: "C004",
      customerName: "Sushma Reddy",
      location: "101 Banjara Hills, Hyderabad, Telangana",
      orderDate: "2024-12-13",
      meds: [
        {
          name: "Med7",
          description: "Pain reliever for muscle and joint pain.",
          company: "PainRelief Co.",
          expiryDate: "2026-11-21",
          tags: ["Pain", "Muscle", "Joint"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 1
        },
        {
          name: "Med8",
          description: "Antihistamine for allergic reactions.",
          company: "HistamineFree",
          expiryDate: "2027-05-17",
          tags: ["Allergy", "Antihistamine", "Relief"],
          ageGroups: ["Adults", "Children"],
          quantity: 2
        }
      ]
    },
    {
      customerId: "C005",
      customerName: "Aarav Singh",
      location: "202 Park Avenue, Mumbai, Maharashtra",
      orderDate: "2024-12-13",
      meds: [
        {
          name: "Med9",
          description: "Antidepressant for anxiety and depression.",
          company: "MentalWell",
          expiryDate: "2025-06-23",
          tags: ["Mental Health", "Depression", "Anxiety"],
          ageGroups: ["Adults"],
          quantity: 1
        },
        {
          name: "Med10",
          description: "Cholesterol-lowering medication.",
          company: "CholestroCare",
          expiryDate: "2026-03-04",
          tags: ["Cholesterol", "Heart Health"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 1
        }
      ]
    },
    {
      customerId: "C006",
      customerName: "Neha Verma",
      location: "303 Beach Road, Chennai, Tamil Nadu",
      orderDate: "2024-12-14",
      meds: [
        {
          name: "Med11",
          description: "Pain reliever for dental pain and post-surgery recovery.",
          company: "DentalPharm",
          expiryDate: "2025-07-29",
          tags: ["Pain", "Dental", "Recovery"],
          ageGroups: ["Adults"],
          quantity: 2
        },
        {
          name: "Med12",
          description: "Probiotic for digestive health.",
          company: "GutBalance",
          expiryDate: "2026-11-05",
          tags: ["Digestive", "Probiotic", "Health"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 1
        }
      ]
    },
    {
      customerId: "C007",
      customerName: "Manoj Kumar",
      location: "404 MG Road, Kolkata, West Bengal",
      orderDate: "2024-12-14",
      meds: [
        {
          name: "Med13",
          description: "Cold medicine for congestion and sore throat relief.",
          company: "ColdMedic",
          expiryDate: "2025-11-12",
          tags: ["Cold", "Congestion", "Sore Throat"],
          ageGroups: ["Adults", "Children"],
          quantity: 1
        },
        {
          name: "Med14",
          description: "Sleep aid for insomnia and sleep disorders.",
          company: "SleepWell",
          expiryDate: "2026-02-20",
          tags: ["Sleep", "Insomnia", "Aid"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 2
        }
      ]
    },
    {
      customerId: "C008",
      customerName: "Geeta Joshi",
      location: "505 Banerjee Street, Pune, Maharashtra",
      orderDate: "2024-12-15",
      meds: [
        {
          name: "Med15",
          description: "Anti-inflammatory medication for arthritis.",
          company: "JointCare",
          expiryDate: "2026-08-04",
          tags: ["Arthritis", "Inflammation", "Pain"],
          ageGroups: ["Adults", "Elderly"],
          quantity: 2
        },
        {
          name: "Med16",
          description: "Antiviral medication for flu treatment.",
          company: "ViroPharm",
          expiryDate: "2025-12-01",
          tags: ["Flu", "Antiviral", "Treatment"],
          ageGroups: ["Adults", "Children"],
          quantity: 1
        }
      ]
    }
  ];
  
  export default Orderreq;
  